export default "__VITE_ASSET__C2lvLYhv__"